import { Maximize } from '@carbon/icons-react'
import { Box, Button, Card, Spinner } from '@chakra-ui/react'
import useKeyPress from 'utils/useKeyPress'

type CardContainerProps = {
  children: React.ReactNode
  loading?: boolean
  expanded: boolean
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>
  className?: string
  width?: string
  minWidth?: string
  height?: string
}

const CardContainer = ({
  children,
  loading,
  expanded,
  setExpanded,
  className,
  width,
  minWidth,
  height,
}: CardContainerProps) => {
  useKeyPress('Escape', () => {
    if (expanded) setExpanded(false)
  })
  if (expanded) {
    return (
      <>
        <Box
          onClick={() => setExpanded(false)}
          p='1rem'
          position={'absolute'}
          bgColor={'black'}
          top={0}
          left={0}
          zIndex={100}
          width='100%'
          opacity={'50%'}
          height='calc(100%)'
          rounded='lg'
        />
        <Card
          p='1rem'
          position={'absolute'}
          top={'20px'}
          left={5}
          zIndex={110}
          width='calc(100% - 40px)'
          height='calc(100% - 40px)'
        >
          {loading ? (
            <Spinner
              position={'absolute'}
              zIndex={20}
              top={1}
              right={1}
              ml={2}
              size={'sm'}
            />
          ) : (
            <ToggleButton expanded={expanded} setExpanded={setExpanded} />
          )}
          {children}
        </Card>
      </>
    )
  }

  return (
    <Card
      borderRadius='8px'
      border='1px'
      borderColor={'gray.200'}
      p={2}
      minW={minWidth || '270px'}
      w={width || '250px'}
      h={height || 'full'}
      maxH={height || 'full'}
      shadow={'none'}
      position={'relative'}
      className={className}
    >
      {loading ? (
        <Spinner
          position={'absolute'}
          zIndex={20}
          top={1}
          right={1}
          ml={2}
          size={'sm'}
        />
      ) : (
        <ToggleButton expanded={expanded} setExpanded={setExpanded} />
      )}
      {children}
    </Card>
  )
}

export default CardContainer

const ToggleButton = ({
  expanded,
  setExpanded,
}: Pick<CardContainerProps, 'expanded' | 'setExpanded'>) => (
  <Button
    onClick={() => setExpanded(!expanded)}
    position='absolute'
    zIndex={10}
    top={1.5}
    right={1}
    opacity={1}
    variant='ghost'
    size='xs'
    px={2}
    rounded='md'
    w={'24px'}
    h={'24px'}
    p={0}
  >
    <Maximize size={12} />
  </Button>
)
